import axios from '@/libs/axios'

export default {
  loadTable(queryFilter) {
    let queryUrl = ''
    queryUrl = `?page=${queryFilter.page - 1}&size=${queryFilter.size}&sort=${
      queryFilter.sort
    },${queryFilter.order}`
    if (queryFilter.filter) {
      queryUrl = `/pesquisa?${queryFilter.filter}`
    }
    return axios.get(`/evento/evento_descontos${queryUrl}`)
  },
  insertNew(data) {
    return axios.post('/evento/evento_descontos', data)
  },
  edit(data) {
    return axios.put(`/evento/evento_descontos/${data.id}`, data)
  },
  delete(id) {
    return axios.delete(`/evento/evento_descontos/${id}`)
  },
  getListEventDiscount() {
    return axios.get('/evento/evento_descontos/evento/1')
  },
  getListTipo() {
    return axios.get('evento/evento_descontos/lista_tipos')
  },
  getListTipoRegistro() {
    return axios.get('/evento/evento_descontos/lista_tipo_registros/1')
  },
}
